/**
 * Wraps all Node components in a default container. If you want to
 * give all Node views a sidebar for example, you would set that here.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import DefaultLayout from "../../../global/components/DefaultLayout.js.jsx";
import Footer from '../../../global/components/navigation/Footer.js.jsx';

class NodeLayout extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="master-layout">
        <div className="body">
          {this.props.children}
        </div>
        <Footer />
      </div>
    )
  }
}

export default NodeLayout;



// WEBPACK FOOTER //
// modules/node/components/NodeLayout.js.jsx